import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

export default function ResultsTable(props) {
  return (
    <TableContainer component={Paper}>
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell align="center">Kolo</TableCell>
            <TableCell align="center">Strana</TableCell>
            <TableCell align="center">Zvuk</TableCell>
            <TableCell align="center">1.</TableCell>
            <TableCell align="center">2.</TableCell>
            <TableCell align="center">Odpoveď</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.table.map((row) => (
            <TableRow
              key={row.questionId}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row" align="center">
                {row.questionId}
              </TableCell>
              <TableCell align="center">{row.sideTested}</TableCell>
              <TableCell align="center">{row.soundName}</TableCell>
              <TableCell align="center">{row.answer1}</TableCell>
              {row.hasOwnProperty("answer2") ? (
                <TableCell align="center">{row.answer2}</TableCell>
              ) : (
                <TableCell align="center">-</TableCell>
              )}
              <TableCell align="center">{row.finalAnswer}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
